var company = {};
module['exports'] = company;
company.prefix = require("./prefix");
company.name = require("./name");



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/vi/company/index.js
// module id = 1840
// module chunks = 1